import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class FirReviewAutomationService {

  constructor(private http: HttpClient) { }

  updateFirTBAutomation(
    baseUrl: string,
    rowData: any,
    globalService: any,
    filterParams: any
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=1m57xp`;

    const gp = globalService?.globalParams || globalService || {};

    const jsonSettings = {
      tax_year: filterParams.tax_year,
      scenario: filterParams.scenario,
      jcd_key: (gp.jcd_key === '' || gp.jcd_key === undefined) ? '250' : gp.jcd_key
    };

    const jsonObj = [{
      EP_TRANSACTION: rowData.EP_TRANSACTION,
      EXCLUDED_YEAR: rowData.EXCLUDED_YEAR,
      COMBINATION_KEY: rowData.COMBINATION_KEY,
      TRANS_HEADER_KEY: rowData.TRANS_HEADER_KEY,
      TRANS_DETAILS_KEY: rowData.TRANS_DETAILS_KEY,
      LOCAL_CHART_KEY: rowData.CHART_KEY,
      TRIGGER_LOCAL_ACCT_KEY: rowData.TRIGGER_LOCAL_ACCT_KEY,
      TRIGGER_SYSTEM_ACCT: rowData.TRIGGER_SYSTEM_ACCT,
      POSTING_LOCAL_ACCT_KEY: rowData.POSTING_ACCT_KEY,
      POSTING_SYSTEM_ACCT: (rowData.POSTING_SYSTEM_ACCT == undefined) ? '' : rowData.POSTING_SYSTEM_ACCT,
      EP_AUTO_KEY: rowData.EP_AUTO_KEY,
      TB_TRANS_HEADER_KEY: rowData.TB_TRANS_HEADER_KEY,
      TB_TRANS_DETAILS_KEY: rowData.TB_TRANS_DETAILS_KEY,
      EP_TYPE: rowData.EP_TYPE_CODE,
      TP_KEY: rowData.TP_KEY,
      ISSUE_KEY: rowData.ISSUE_KEY
    }];

    let params: any = _.merge({}, gp, filterParams);
    params = _.extend({ jsonObj: JSON.stringify(jsonObj) }, params);
    params = _.extend({ jsonSettings: JSON.stringify(jsonSettings) }, params);
    params.process_name = 'FIR TB AUTOMATION';

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}
